<template>
  <div class="rounded-md border-2 border-dashed border-gray-300 bg-neutral-50 shadow p-3 m-2">
    <div class="flex flex-row items-center justify-between mb-2">
      <div class="flex flex-row items-center space-x-2">
        <div class="text-sm tracking-widest text-gray-700 font-poppins uppercase">
          {{ title }}
        </div>
        <SampleBadge />
      </div>
      <div v-if="subtitle" class="text-xs text-gray-500">{{ subtitle }}</div>
    </div>
    <div
      :class="[
        'flex flex-row items-end justify-around bg-gray-100 rounded border border-dashed border-gray-300 p-2 space-x-1',
        heightClass,
      ]"
    >
      <div
        v-for="(h, i) in bars"
        :key="i"
        class="flex-1 rounded-t bg-accent-primary opacity-70"
        :style="{ height: h + '%' }"
      ></div>
    </div>
    <div class="mt-2 text-xs text-gray-400 italic text-center">
      Placeholder visualization &mdash; real chart to be wired to data.
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import SampleBadge from './SampleBadge.vue'

const props = defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
  barCount: { type: Number, default: 14 },
  tall: { type: Boolean, default: false },
  seed: { type: Number, default: 1 },
})

const heightClass = computed(() => (props.tall ? 'h-64' : 'h-40'))

const bars = computed(() => {
  const out = []
  let x = props.seed * 9301 + 49297
  for (let i = 0; i < props.barCount; i++) {
    x = (x * 9301 + 49297) % 233280
    const r = x / 233280
    out.push(20 + Math.floor(r * 75))
  }
  return out
})
</script>